import React from 'react';
import { DateTime } from 'luxon';

class DateTimeCellComponent extends React.Component {

  render() {
    const { value, format } = this.props;
    return DateTime.fromJSDate(new Date(value)).toLocaleString(format || DateTime.DATETIME_MED_WITH_SECONDS)
  }

}

export default DateTimeCellComponent;


// WEBPACK FOOTER //
// ./src/views/common/datetime-cell.js